<template>
  <div
    class="tw-flex tw-items-center tw-space-x-1 tw-h-4 tw-opacity-50"
    :class="{ 'lg:tw-hidden': Settings.nameRightSide }"
  >
    <div
      class="tw-space-x-2 tw-flex tw-items-center tw-text-nowrap tw-text-sm tw-font-medium"
    >
      <base-link
        class="tw-block tw-relative"
        :to="{ path: '/' }"
        :link-primary="false"
      >
        <base-button text-link-hover icon="home" icon-size="sm" />
      </base-link>
      <template v-if="isMod || isCollection || isGuide">
        <font-awesome-icon size="sm" icon="chevron-right" />
        <base-link
          class="tw-truncate"
          hover-primary
          :link-primary="false"
          :to="{
            name: libraryBreadcrumb
              ? LIBRARY_ROUTE
              : isMod
                ? MOD_BROWSE_ROUTE
                : isCollection
                  ? COLLECTION_BROWSE_ROUTE
                  : GUIDE_BROWSE_ROUTE,
          }"
        >
          {{
            libraryBreadcrumb
              ? $t('library')
              : isMod
                ? ugcNameText
                : isCollection
                  ? $t('collection', 2)
                  : $t('guide', 2)
          }}
        </base-link>
        <template v-if="tagName">
          <font-awesome-icon size="sm" icon="chevron-right" />
          <base-link
            hover-primary
            :link-primary="false"
            class="tw-truncate tw-capitalize"
            :to="{
              name: libraryBreadcrumb
                ? LIBRARY_ROUTE
                : isMod
                  ? MOD_BROWSE_ROUTE
                  : isCollection
                    ? COLLECTION_BROWSE_ROUTE
                    : GUIDE_BROWSE_ROUTE,
              query: isCollection
                ? { category: tagName.name }
                : { tags: tagName.name },
            }"
          >
            {{
              tagName.name_localized ??
              (tagName.key ? $t(tagName.key) : tagName.name)
            }}
          </base-link>
        </template>
        <template v-if="subTagName">
          <font-awesome-icon size="sm" icon="chevron-right" />
          <base-link
            hover-primary
            :link-primary="false"
            class="tw-truncate tw-capitalize"
            :to="{
              name: libraryBreadcrumb
                ? LIBRARY_ROUTE
                : isMod
                  ? MOD_BROWSE_ROUTE
                  : isCollection
                    ? COLLECTION_BROWSE_ROUTE
                    : GUIDE_BROWSE_ROUTE,
              query: {
                tags: subTagName.name,
              },
            }"
          >
            {{
              subTagName.name_localized ??
              (subTagName.key ? $t(subTagName.key) : subTagName.name)
            }}
          </base-link>
        </template>
      </template>
    </div>
  </div>
</template>
<script>
import { useResourceValue, useTags } from '@composables'
import { ITEM_TYPES } from '@config/options.js'
import i18n from '@plugins/localisation.js'
import { Settings } from '@config/game.js'
import { computed, toRefs } from 'vue'
import { gameStore } from '@stores'
import {
  COLLECTION_BROWSE_ROUTE,
  GUIDE_BROWSE_ROUTE,
  MOD_BROWSE_ROUTE,
  LIBRARY_ROUTE,
} from '@config/routeNames.js'

export default {
  props: {
    itemType: {
      type: String,
      required: true,
      validation: (val) => Object.values(ITEM_TYPES).includes(val),
    },
    guide: {
      type: Object,
      default: undefined,
    },
    mod: {
      type: Object,
      default: undefined,
    },
    collection: {
      type: Object,
      default: undefined,
    },
    libraryBreadcrumb: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const { itemType, mod, guide, collection } = toRefs(props)

    const t = i18n.global.t

    const { ugcName } = useResourceValue()
    const { getPublicGame } = gameStore()
    const game = getPublicGame()

    const ugcNameText = computed(() => {
      let _ugcNameText = ugcName(null, false, false).value

      if (['mods', 'levels'].includes(_ugcNameText.toLowerCase())) {
        _ugcNameText = t(_ugcNameText.split('s')[0].toLowerCase(), 2)
      }

      return _ugcNameText
    })

    const isCollection = itemType.value === ITEM_TYPES.COLLECTION
    const isGuide = itemType.value === ITEM_TYPES.GUIDE
    const isMod = itemType.value === ITEM_TYPES.MOD

    const { tagName, subTagName } = useTags(
      game,
      isMod ? mod : isCollection ? collection : guide,
      itemType
    )

    return {
      COLLECTION_BROWSE_ROUTE,
      GUIDE_BROWSE_ROUTE,
      MOD_BROWSE_ROUTE,
      LIBRARY_ROUTE,
      isCollection,
      ugcNameText,
      subTagName,
      Settings,
      tagName,
      isGuide,
      isMod,
    }
  },
}
</script>
